import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import additionalInfoImage from 'assets/images/help-general-pdp-additional-info.png';
import carouselImage from 'assets/images/help-general-pdp-images.png';
import webInfoImage from 'assets/images/help-general-pdp-web-info.png';
import HelpImage from 'ui/help/HelpImage';
import { DomId } from 'constants/DomId';

// TODO internationalize if we end up caring about it

const HelpGeneralPDP = () => {
  return (
    <Box>
      <Typography variant='body1'>
        The product details page is where you can find all the relevant item
        information for a specific product. The search view can provide a great
        deal of information, but some is a little more difficult to get on the
        fly, so we only show some product details on the product detail page.
        This help section will cover the functionality of this page.
      </Typography>
      <br />
      <Typography variant='body1'>
        One of the major sections of the product details page is the table shown
        below. This is the information that ends up getting shown to users in
        our web portal of myUNFI.
      </Typography>
      <br />
      <Typography variant='body1'>
        You can customize this view to your liking. You can show/hide rows so
        only information relevant to you for an item is shown in this view. More
        information about how to customize your views can be found at{' '}
        <Link component={RouterLink} to={`#${DomId.HelpCustomizingViews}`}>
          this help topic.
        </Link>
      </Typography>
      <HelpImage imageSrc={webInfoImage} alt='public web information' />
      <Typography variant='body1'>
        Another major section of the product display page is the image carousel.
        This shows all of the potential images that will be shown for an item,
        along with some additional information about the item images. You can
        find out more about image information at{' '}
        <Link component={RouterLink} to={`#${DomId.HelpImages}`}>
          this help topic.
        </Link>
      </Typography>
      <HelpImage imageSrc={carouselImage} alt='product detail images' />
      <Typography variant='body1'>
        The last major section of the product details page has some additional
        information that is a little more difficult to get on the search page,
        or that is difficult to view in a small table column. You can find out
        more about some of these sections at{' '}
        <Link component={RouterLink} to={`#${DomId.HelpAvailability}`}>
          the availability help section
        </Link>{' '}
        or in the{' '}
        <Link component={RouterLink} to={`#${DomId.HelpSources}`}>
          the sources help section.
        </Link>
      </Typography>
      <HelpImage
        imageSrc={additionalInfoImage}
        alt='detailed item information'
      />
    </Box>
  );
};

export default HelpGeneralPDP;
